// MA-497 (Journey v3, PR-B) — shared reduced-motion check, extracted from
// JourneyPath.tsx's own local `motionAllowed` (MA-496) so a SECOND surface
// (BottomTabBar.tsx's tab-pulse/flying-dot pick feedback, A12) can honor
// the same dual discipline — the OS `prefers-reduced-motion` media query
// AND the app's own manual "Reduce motion" setting (`.reduce-motion` on
// `<html>`) — without re-typing the check.
export function motionAllowed(): boolean {
  if (typeof window === "undefined") return false;
  const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
  const reducedClass = document.documentElement.classList.contains("reduce-motion");
  return !prefersReduced && !reducedClass;
}
